import { Controller } from "stimulus"
import Choices from "choices.js"

export default class extends Controller {
  static targets = [
    "container",
    "input",
    "assetClass",
    "vintage",
    "stage",
    "managed",
    "downloadOverview",
    "downloadFull",
    "clearFiltersButton",
    "loadingIndicator",
  ]

  clearFilters() {
    if (this.hasLoadingIndicatorTarget) {
      this.loadingIndicatorTarget.classList.add("active")
    }
    window.location.reload()
  }

  connect() {
    this.$el = $(this.element)
    this.timeout = null
    this.req = null
    this.currentSort = "name"
    this.currentSortDirection = "asc"

    const defaultChoicesOptions = {
      searchEnabled: false,
      itemSelectText: "",
      allowHTML: true,
      shouldSort: false,
    }

    this.choices = []

    this.constructor.targets.forEach((target) => {
      if (
        this[
          "has" + target.charAt(0).toUpperCase() + target.slice(1) + "Target"
        ]
      ) {
        const targetEl = this[`${target}Target`]
        this[`$${target}`] = $(targetEl)

        if (targetEl.nodeName === "SELECT") {
          const dataChoicesConfig = targetEl.dataset.choicesConfig
          let choicesOptions = { ...defaultChoicesOptions }

          if (dataChoicesConfig) {
            try {
              const parsedConfig = JSON.parse(dataChoicesConfig)
              choicesOptions = { ...choicesOptions, ...parsedConfig }
            } catch (e) {
              console.error("Invalid JSON in data-choices-config:", e)
            }
          }

          this.choices.push(new Choices(targetEl, choicesOptions))
        }
      }
    })

    this.$input.on("change keyup", () => {
      this.updateSearchIcon()
      clearTimeout(this.timeout)
      this.timeout = setTimeout(this.doSearch.bind(this), 250)
    })
  }

  updateSearchIcon() {
    this.$input
      .closest(".form-group")
      .toggleClass("searching", this.$input.val().length > 0)
  }

  onSortTable(e) {
    const sort = e.currentTarget.dataset.sort

    // swap sort direction
    if (this.currentSort == sort) {
      this.currentSortDirection =
        this.currentSortDirection == "asc" ? "desc" : "asc"
    } else {
      // initialize sort direction
      this.currentSortDirection = "asc"
      this.currentSort = sort
    }

    this.doFilter()
  }

  doSearch() {
    if (this.lastSearch !== null && this.$input.val() == this.lastSearch) {
      return
    }

    this.lastSearch = null

    this.doFilter()
  }

  doFilter() {
    const query = this.$input.val()
    const data = {
      q: query,
      asset_class: this.$assetClass.val(),
      vintage: this.$vintage.val(),
      stage: this.$stage.val(),
      managed: this.$managed.val(),
      sort: this.currentSort,
      sort_direction: this.currentSortDirection,
    }

    if (this.hasLoadingIndicatorTarget) {
      this.loadingIndicatorTarget.classList.add("active")
    }

    // Track the current request with a timestamp
    // This is so removing the loading indicator is only triggered by the most
    // recent request
    this.currentRequestTimestamp = Date.now()
    const requestTimestamp = this.currentRequestTimestamp

    // Always hide the loading indicator after 10 seconds.
    // The page is still functional during a loading state, so removing it as
    // a failsafe should allow for any race conditions or issue with the remove
    // logic and still have the page work.
    setTimeout(() => {
      if (
        this.hasLoadingIndicatorTarget &&
        this.currentRequestTimestamp === requestTimestamp
      ) {
        this.loadingIndicatorTarget.classList.remove("active")
      }
    }, 10000)

    const params = new URLSearchParams()
    Object.keys(data).forEach((key) => {
      if (data[key].length) {
        params.set(key, data[key])
      }
    })

    if (this.hasDownloadOverviewTarget) {
      this.downloadOverviewTarget.href = `${
        this.element.dataset.url
      }?export=overview&${params.toString()}`
    }
    if (this.hasDownloadFullTarget) {
      this.downloadFullTarget.href = `${
        this.element.dataset.url
      }?export=full&${params.toString()}`
    }

    if (this.req) {
      this.req.abort()
    }

    this.req = $.get({
      url: this.element.dataset.url,
      data: data,
      success: (response) => {
        // Only process the response if this is still the current request
        if (this.currentRequestTimestamp === requestTimestamp) {
          this.$container.find('[data-bs-toggle="tooltip"]').tooltip("dispose")
          this.$container
            .html(response)
            .find('[data-bs-toggle="tooltip"]')
            .tooltip()
          this.lastSearch = query
          this.req = null

          if (this.hasLoadingIndicatorTarget) {
            this.loadingIndicatorTarget.classList.remove("active")
          }
        }
      },
      error: () => {
        if (
          this.currentRequestTimestamp === requestTimestamp &&
          this.hasLoadingIndicatorTarget
        ) {
          this.loadingIndicatorTarget.classList.remove("active")
        }
      },
    })
  }

  onClearSearch() {
    this.lastSearch = null
    this.$input.val("")
    this.updateSearchIcon()
    this.doFilter()
  }

  onExpand(e) {
    const $parentRow = $(e.currentTarget).closest("tr")
    const securityId = $parentRow.data("id")
    const expand = !$parentRow.hasClass("expanded")

    // hackery for the sticky table

    const expandRow = ($row) => {
      $row.toggleClass("expanded", expand)

      let $nextRow = $row.next(".b-investments-table-investment")
      while ($nextRow.length > 0) {
        $nextRow = $nextRow
          .toggleClass("expanded", expand)
          .next(".b-investments-table-investment")
      }
    }

    expandRow($parentRow)
    expandRow(
      $parentRow
        .closest(".b-investments-sticky")
        .prev()
        .find(`[data-id=${securityId}]`),
    )
  }
}
